import DepartmentJobOpening from "./departmentJobOpening";
export default DepartmentJobOpening;